import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsSoftwareConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-products-software-config',
	path: '/secure/SoftwareConfig.jspa',
	query: ['decorator=admin'],
};
